import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { isValidNameWithSpace, renderTextArea, renderTextField ,renderCheckBox} from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import { saveNoteTypes, getNoteTypeDetails } from '../actions/NoteActions';
import validate from '../validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError } from '../../../../../../src/actions/utilAction';
import SmallLoader from '../../../../../img/small-loader.gif';

class NoteTypeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      noteTypeId: props.noteTypeId,
    };
  }
  

  componentWillMount() {
    if (this.state.noteTypeId)
      this.props.getNoteTypeDetails(this.state.noteTypeId);
  }

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }
  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      // console.log('labelName.........',labelName)
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.props.noteTypeId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  onSubmitHandler(formData) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formData.id = this.state.noteTypeId ? this.state.noteTypeId : 0;
    formData.type = formData.type.trim();
    formData.description = formData.description ? formData.description.trim() : '';
    formData.navigation= this.state.navigationLink
    this.props.clearFieldErrorArray();
    // console.log('formdata ', JSON.stringify(formData));
    this.props.saveNoteTypes(formData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }


  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.state.noteTypeId ? 'Edit Note Type' : 'Add Note Type'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12  require">
                  <Field
                    autoFocus={true}
                    name="type"
                    type="text"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Note Type')}
                    customError={displayCustomError('TYPE', this.props.fieldError)}
                    maxLength="50"
                    label="Note Type"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} 
                    />
                </div>
                <div className="col-sm-12 col-md-12">
                  <Field
                    name="description"
                    type="text"
                    maxLength="1000"
                    label="Description"
                    component={renderTextArea} />
                  <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                </div>
                {/* <div className="col-sm-12 col-md-12">
                  <Field
                    name="navigationLink"
                    type="text"
                    maxLength="1000"
                    label="Navigation Link"
                    component={renderTextArea} />
                </div> */}
                <div className="row">
                  <div className="col-sm-3">
                    <Field
                      className="mt20 mb0"
                      name="isActive"
                      label="Is Active"
                      component={renderCheckBox}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field
                      className="mt20 mb0"
                      name="requireNarrativeSummary"
                      label="Require Narrative Summary"
                      component={renderCheckBox}
                    />
                  </div>
              </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}
const selector = formValueSelector('NoteTypeModalForm');
function mapStateToProps(state, ownProps) {
  // let fieldError_Code = null;
  // let fieldError_Type = null;

  // if (state.appConfig && state.appConfig.fieldError) {
  //   fieldError_Code = state.appConfig.fieldError.filter((obj, i) => obj.data === 'NOTECODE');
  //   fieldError_Type = state.appConfig.fieldError.filter((obj, i) => obj.data === 'NOTETYPE');
  // }

  let initialValueData = null;
  if (ownProps.noteTypeId && state.noteType.noteTypeDetails) {
    initialValueData = state.noteType.noteTypeDetails.data;
  }
  return {
    loading: state.noteType.loading,
    description: selector(state, 'description'),
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  };
}
NoteTypeModal = reduxForm({
  form: 'NoteTypeModalForm',
  validate,
  enableReinitialize: true,
})(NoteTypeModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveNoteTypes, getNoteTypeDetails })(NoteTypeModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/note-master/components/Note_Modal.js